import React from 'react'
import { useRef, useState, useEffect, useContext, useLayoutEffect, useMemo } from 'react'
import { Stack, Text, TextField, Dropdown, IDropdownOption, Slider, PrimaryButton, Icon } from '@fluentui/react'

import {
  IDropdownProps,
  IRenderFunction,
  ITextFieldStyles,
  IDropdownStyles,
  ISliderStyles,
  IButtonStyles
} from '@fluentui/react'
import BrainIcon from '../../assets/new assets/Brain.svg'
import FilesIcon from '../../assets/new assets/Files.svg'
import WebIcon from '../../assets/new assets/Web.svg'
import LibraryIcon from '../../assets/new assets/Library.svg'
import HelpIcon from '../../assets/new assets/Help button.svg'
import SearchIcon from '../../assets/new assets/Search.svg'
import ParagraphIcon from '../../assets/new assets/Paragraph.svg'
import IdeaIcon from '../../assets/new assets/Idea.svg'
import LiteratureIcon from '../../assets/new assets/Literature.svg'
import ETF from '../../assets/logo.png'
import RefreshIcon from '../../assets/new assets/Refresh.svg'
import FileSearchIcon from '../../assets/new assets/File search.svg'
import EditIcon from '../../assets/new assets/Edit.svg'
import ChatIcon from '../../assets/new assets/Chat.svg'
import MenuIcon from '../../assets/new assets/Menu.svg'
import UpIcon from '../../assets/new assets/Chevron up.svg'
import DownIcon from '../../assets/new assets/Chevron down.svg'
import RightIcon from '../../assets/new assets/Chevron right.svg'
import LeftIcon from '../../assets/new assets/Chevron left.svg'
import WizardIcon from '../../assets/new assets/Wizard.svg'
import FilterIcon from '../../assets/new assets/Filters.svg'
import DownloadIcon from '../../assets/new assets/Download.svg'
import WordIcon from '../../assets/new assets/Word.svg'
import CSVIcon from '../../assets/new assets/CSV.svg'
import PlusIcon from '../../assets/new assets/Plus.svg'
import CloseIcon from '../../assets/new assets/Close.svg'

import DotFilled from '../../assets/new assets/Step status.svg'
import Dot from '../../assets/new assets/Step status (1).svg'
import { AppStateContext } from '../../state/AppProvider'
import styles from './LitReview.module.css'
import './CombinedButtonDropdown.css'
import { useNavigate, useLocation } from 'react-router-dom'

import {
  fetchLitReviewKeywords,
  fetchArticles,
  Article,
  GetArticlesParams,
  fetchLitReview,
  GetLitReviewParams,
  LitReviewOutput,
  downloadLitReviewDocx,
  downloadLitReviewCsv
} from '../../api'
import { set } from 'lodash'

const steps = [
  { label: 'Research', icon: '🔭' },
  { label: 'Keywords', icon: '💡' },
  { label: 'References', icon: '📚' },
  { label: 'Review', icon: '📝' }
]

const keywordsexample = [
  'Albania education system',
  'Educational reform in Albania',
  'Higher education in Albania',
  'Primary and secondary education Albania',
  'Education policy Albania',
  'Access to education in Albania',
  'Quality of education in Albania',
  'Teacher training in Albania',
  'Albania curriculum development',
  'International aid and education in Albania'
]

const documents = [
  'A Longitudinal Study on Neural Plasticity in Bilingual Albanian Preschoolers',
  'The Impact of Mountainous Terrain on Cognitive Development in Albanian Rural Schools',
  'Quantum Pedagogy: A Theoretical Framework for Nonlinear Learning in Albanian Classrooms',
  'Correlation Between Traditional Albanian Folk Music and Mathematical Reasoning in Early Education',
  'Evaluating the Efficacy of Solar-Powered Smart Desks in Northern Albanian Schools',
  'Neurocognitive Effects of Multilingual Education Policies in Post-Communist Albania',
  'Artificial Intelligence Integration in Secondary Education: A Case Study from Tirana',
  'Measuring Emotional Intelligence Outcomes from Goat-Assisted Learning Models in Southern Albania',
  'Theoretical Implications of Time-Compressed Learning in Urban Albanian High Schools',
  'Virtual Reality as a Tool for Teaching Albanian History: A Controlled Experimental Design'
]

const placeholderText =
  'Aeneadum genetrix, hominum divomque voluptas,alma Venus, caeli subter labentia signa quae mare navigerum, quae terras frugiferentis concelebras, per te quoniam genus omne animantum concipitur visitque exortum lumina solis...'

//testing comment
const dropdownWidth = 314 // (660 - 32) / 2
const openFilterButtonStyles: Partial<IButtonStyles> = {
  root: {
    width: 180,
    height: 40,
    backgroundColor: '#FFFFFF',
    border: '1px solid #DEE5EB',
    borderRadius: 9999,
    padding: '8px 12px',
    color: '#404D59',
    fontWeight: 'medium',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 12,
    margin: '0 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out'
  },
  rootHovered: {
    backgroundColor: '#007bb3',
    color: 'white'
  }
}
const restartButtonStyles: Partial<IButtonStyles> = {
  root: {
    width: 113,
    height: 40,
    backgroundColor: '#FFFFFF',
    border: '1px solid #DEE5EB',
    borderRadius: 9999,
    padding: '8px 12px',
    color: '#404D59',
    fontWeight: 'medium',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 12,
    margin: '0 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out'
  },
  rootHovered: {
    backgroundColor: '#007bb3',
    color: 'white'
  }
}
const nextStepButtonStyles: Partial<IButtonStyles> = {
  root: {
    width: 200,
    height: 40,
    backgroundColor: '#009CDA',
    borderRadius: 9999,
    padding: '8px 16px',
    color: 'white',
    fontWeight: 'bold',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 12,
    transition: 'all 300ms ease-in-out',
    margin: '0 4px',
    display: 'block'
  },
  rootHovered: {
    backgroundColor: '#007bb3'
  }
}

const previousStepButtonStyles: Partial<IButtonStyles> = {
  root: {
    width: 200,
    height: 40,
    backgroundColor: '#FFFFFF',
    borderColor: '#DEE5EB',
    borderRadius: 9999,
    padding: '8px 0px',
    color: '#404D59',
    fontWeight: 'bold',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 12,
    transition: 'all 300ms ease-in-out',
    margin: '0 4px',
    display: 'block'
  },
  rootHovered: {
    backgroundColor: '#007bb3'
  }
}

const customDropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: '25%'
  },
  label: {
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    color: '#677179',
    fontWeight: 600,
    marginBottom: 6
  },
  dropdown: {
    backgroundColor: 'white',
    border: '1px solid #DEE5EB',
    borderRadius: 999,
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    paddingLeft: 0,
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 14,
    color: '#303133',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  caretDownWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}

const customDropdownStylesStep3: Partial<IDropdownStyles> = {
  root: {
    width: '50%'
  },
  label: {
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    color: '#677179',
    fontWeight: 600
  },
  dropdown: {
    backgroundColor: 'white',
    border: '1px solid #DEE5EB',
    borderRadius: 999,
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    paddingLeft: 0,
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 14,
    color: '#303133',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  caretDownWrapper: {
    display: 'flex',
    alignItems: 'center'
  }
}
const customDropdownStylesSidebar: Partial<IDropdownStyles> = {
  root: {
    width: '25%'
  },
  label: {
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    color: '#677179',
    fontWeight: 600,
    marginBottom: 6
  },
  dropdown: {
    backgroundColor: 'white',
    border: '1px solid #DEE5EB',
    borderRadius: 999,
    height: 40,
    paddingLeft: 16,
    paddingRight: 16,
    display: 'flex',
    alignItems: 'center'
  },
  title: {
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: 'transparent',
    paddingLeft: 0,
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 14,
    color: '#303133',
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  caretDownWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  callout: {
    borderRadius: 12,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
    border: '1px solid #DEE5EB',
    marginTop: 6, // spacing between control and dropdown
    paddingTop: 8, // vertical padding inside menu
    paddingBottom: 8,
    backgroundColor: '#ffffff',
    minWidth: 180, // ensure the dropdown has enough width to render
    position: 'absolute', // help it break out of narrow parents
    zIndex: 1002 // above the sidebar and toggle button
  },

  dropdownItemsWrapper: {
    backgroundColor: '#ffffff'
  },

  dropdownItem: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 14,
    color: '#303133',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 12,
    paddingRight: 12,
    lineHeight: '20px',
    selectors: {
      ':hover': {
        backgroundColor: '#F3F6F9',
        color: '#000'
      }
    }
  }
}

const sliderStyles: Partial<ISliderStyles> = {
  root: {
    width: 314,
    fontFamily: 'Montserrat, sans-serif'
  },
  titleLabel: {
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    color: '#677179',
    fontWeight: 600,
    marginBottom: 6
  },
  container: {
    marginTop: 8
  },
  slideBox: {
    marginTop: 16,
    height: 8
  },
  line: {
    backgroundColor: '#cfe8fb',
    height: 4,
    borderRadius: 4,
    marginTop: -10
  },
  activeSection: {
    backgroundColor: '#0094E5',
    height: 4
  },
  thumb: {
    backgroundColor: '#0094E5',
    border: '2px solid white',
    width: 16,
    height: 16,
    borderRadius: '50%',
    marginTop: 0
  },
  valueLabel: {
    color: '#2c3e50',
    padding: '2px 8px',
    fontSize: 12,
    marginTop: 10
  }
}

const customTextFieldStyles: Partial<ITextFieldStyles> = {
  root: {
    width: 660,
    height: 57,
    opacity: 1
  },
  fieldGroup: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #DEE5EB',
    paddingTop: 16,
    paddingRight: 24,
    paddingBottom: 16,
    paddingLeft: 24,
    height: 57,
    boxShadow: '0px 2px 4px rgba(48, 51, 54, 0.10)',
    selectors: {
      ':hover': {
        borderColor: '#d0e7ff'
      },
      ':focus-within': {
        borderColor: 'transparent',
        boxShadow: 'none',
        backgroundColor: '#f0f6ff'
      }
    }
  },
  field: {
    color: '#333',
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    height: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    resize: 'none',
    '::placeholder': {
      color: '#677179'
    }
  }
}

const customTextFieldStylesSmall: Partial<ITextFieldStyles> = {
  root: {
    width: 300,
    height: 57,
    opacity: 1
  },
  fieldGroup: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    border: '1px solid #DEE5EB',
    paddingTop: 16,
    paddingRight: 24,
    paddingBottom: 16,
    paddingLeft: 24,
    height: 10,
    boxShadow: '0px 2px 4px rgba(48, 51, 54, 0.10)',
    selectors: {
      ':hover': {
        borderColor: '#d0e7ff'
      },
      ':focus-within': {
        borderColor: 'transparent',
        boxShadow: 'none',
        backgroundColor: '#f0f6ff'
      }
    }
  },
  field: {
    color: '#333',
    fontSize: 14,
    fontFamily: 'Montserrat, sans-serif',
    height: 10,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    resize: 'none',
    '::placeholder': {
      color: '#677179'
    }
  },
  suffix: {
    background: 'transparent',
    padding: 0,
    margin: 0
  }
}

const SELECT_ALL_KEY = 'ALL'

const withSelectAllOption = (options: IDropdownOption[]) => [{ key: SELECT_ALL_KEY, text: 'Select All' }, ...options]

const getSelectedKeysWithAll = (selected: IDropdownOption[], allOptions: IDropdownOption[]): string[] => {
  const allSelected = selected.length === allOptions.length

  if (allSelected) {
    return [SELECT_ALL_KEY, ...allOptions.map(o => String(o.key))]
  }

  return selected.map(o => String(o.key))
}

const handleMultiSelectChange = (
  option: IDropdownOption | undefined,
  selected: IDropdownOption[],
  allOptions: IDropdownOption[],
  setSelected: (value: IDropdownOption[]) => void,
  resetKeywords: () => void
) => {
  if (!option) return

  if (option.key === SELECT_ALL_KEY) {
    setSelected(option.selected ? [...allOptions] : [])
    return
  }

  const updated = option.selected ? [...selected, option] : selected.filter(o => o.key !== option.key)

  setSelected(updated)
  resetKeywords()
}

const dropdownOptions: IDropdownOption[] = [
  { key: 'placeholder1', text: 'Placeholder Option 1' },
  { key: 'placeholder2', text: 'Placeholder Option 2' }
]

const dropdownSourcesOptions: IDropdownOption[] = [
  { key: 'SEMANTICSCHOLAR', text: 'Semantic Scholar' },
  //{ key: 'UNESCO', text: 'UNESCO' },
  { key: 'WORLDBANK', text: 'World Bank' },
  { key: 'UNESCODOC', text: 'UNESCO Documents' },
  { key: 'ETF', text: 'European Training Foundation (ETF)' },
  { key: 'EU_PO', text: 'EU Publications Office' },
  { key: 'ILO', text: 'International Labour Organization (ILO)' },
  { key: 'JRC', text: 'Joint Research Centre (JRC)' },
  //{ key: 'OECD', text: 'OECD' },
  { key: 'OPENALEX', text: 'OpenAlex' },
  //{ key: 'CEDEFOP', text: 'Cedefop' }
]

const dropdownDocTypesOptions: IDropdownOption[] = [
  { key: 'ARTICLE', text: 'Article' },
  { key: 'BOOK', text: 'Book' },
  { key: 'CHAPTER', text: 'Chapter' },
  { key: 'REPORT', text: 'Report' },
  { key: 'JOURNAL', text: 'Journal' },
  { key: 'REVIEW', text: 'Review' }
]

const exampleDescriptions = [
  'Impact of AI on the labour market',
  'Lorem ipsum dolor sit amet',
  'Lorem ipsum dolor sit amet',
  'Lorem ipsum dolor sit amet'
]

const sidebarSteps = [
  { icon: 'NumberedList', label: 'Step 1: Research' },
  { icon: 'Search', label: 'Step 2: Keywords' },
  { icon: 'ReadingMode', label: 'Step 3: References' },
  { icon: 'ReviewRequestMirrored', label: 'Step 4: Review' }
]
const CollapsibleTextBox = ({ title, content }: { title: string; content: string }) => {
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div
      style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        width: '580px',
        margin: '0 auto',
        fontFamily: 'Montserrat, sans-serif',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s ease',
        position: 'relative'
      }}>
      <div
        style={{
          fontWeight: 600,
          fontSize: '16px',
          color: '#404D59',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer'
        }}
        onClick={() => setIsOpen(!isOpen)}>
        {title}
        <span
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
            fontSize: '18px'
          }}>
          ⌃
        </span>
      </div>

      {isOpen && (
        <p
          style={{
            marginTop: '16px',
            fontWeight: 400,
            fontSize: '14px',
            color: '#555',
            lineHeight: 1.6,
            whiteSpace: 'pre-line'
          }}>
          {content}
        </p>
      )}
    </div>
  )
}

const KeywordButton = ({
  label,
  isSelected,
  onSelectionChange,
  onLabelChange // <- Optional: if you want to lift state
}: {
  label: string
  isSelected: boolean
  onSelectionChange: (isSelected: boolean) => void
  onLabelChange?: (newLabel: string) => void
}) => {
  const [isEditing, setIsEditing] = useState(false)
  const [editValue, setEditValue] = useState(label)

  const handleBoxClick = () => {
    if (!isEditing) {
      const newSelection = !isSelected
      setEditValue(label)
      onSelectionChange(newSelection)
    }
  }

  const handleIconClick = (event: React.MouseEvent) => {
    setEditValue(label)
    event.stopPropagation()
    setIsEditing(true)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditValue(e.target.value)
  }

  const handleInputBlur = () => {
    setIsEditing(false)
    if (editValue !== label) {
      onLabelChange?.(editValue) // Inform parent if needed
    }
  }

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      ;(e.target as HTMLInputElement).blur() // Trigger blur to save
    }
  }

  return (
    <div
      onClick={handleBoxClick}
      style={{
        width: '338px',
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 24px',
        backgroundColor: 'white',
        borderRadius: '16px',
        cursor: 'pointer',
        opacity: 1
      }}>
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        style={{ marginRight: '10px', accentColor: '#009CDA', transform: 'scale(1.5)' }}
      />
      {isEditing ? (
        <input
          value={editValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onKeyDown={handleInputKeyDown}
          autoFocus
          style={{
            flex: 1, //HERE
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            fontSize: 14,
            color: '#404D59',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '2px 6px'
          }}
        />
      ) : (
        <span
          style={{
            flex: 1,
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 400,
            color: '#404D59',
            fontSize: 14,
            lineHeight: '100%'
          }}>
          {label}
        </span>
      )}
      <button
        onClick={handleIconClick}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '20px'
        }}>
        <img
          src={EditIcon}
          style={{
            width: 20,
            height: 20,
            filter:
              'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)'
          }}
        />
      </button>
    </div>
  )
}

const DocumentButton = ({
  label,
  abstract,
  isSelected,
  article,
  onSelectionChange,
  setArticle,
  setIsArticleOpened
}: {
  label: string
  abstract: string
  article: Article
  isSelected: boolean
  onSelectionChange: (isSelected: boolean) => void
  setArticle: (setArticle: Article) => void
  setIsArticleOpened: (boolean: boolean) => void
}) => {
  console.log(article)
  const handleBoxClick = () => {
    const newSelection = !isSelected
    onSelectionChange(newSelection) // Inform parent
  }

  const handleIconClick = (event: React.MouseEvent) => {
    event.stopPropagation() // Prevent toggle
    setArticle(article)
    setIsArticleOpened(true)
    console.log(article)
  }

  return (
    <div
      onClick={handleBoxClick}
      style={{
        position: 'relative', // enable absolute positioning inside
        width: '700px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start', // keep items aligned to the left
        padding: '12px 24px',
        backgroundColor: 'white',
        borderRadius: '16px',
        cursor: 'pointer',
        opacity: 1,
        boxSizing: 'border-box'
      }}>
      <input
        type="checkbox"
        checked={isSelected}
        readOnly
        style={{
          marginRight: '10px',
          accentColor: '#009CDA',
          transform: 'scale(1.5)'
        }}
      />
      <div
        style={{
          maxWidth: '800px',
          textAlign: 'left',
          fontFamily: 'Montserrat, sans-serif',
          paddingRight: '40px', // << Add this line to leave space for the icon
          paddingLeft: '10px'
        }}>
        <div style={{ fontWeight: 600, fontSize: '16px', marginBottom: '8px', color: '#404D59' }}>{label}</div>
        <div style={{ fontWeight: 400, fontSize: '14px', lineHeight: '1.5', color: '#555' }}>{abstract}</div>
      </div>

      {/* Absolutely positioned icon in top right */}
      <button
        onClick={handleIconClick}
        style={{
          position: 'absolute',
          top: '12px',
          right: '20px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 0
        }}>
        <img
          src={FileSearchIcon}
          alt="icon"
          style={{
            width: 20,
            height: 20,
            filter:
              'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)'
          }}
        />
      </button>
    </div>
  )
}

type CombinedButtonDropdownProps = {
  onMainClick: () => void
  dropdownOptions: IDropdownOption[]
  onSelect: (option: IDropdownOption) => void
  isShrunk: boolean
}
const CombinedButtonDropdown: React.FC<CombinedButtonDropdownProps> = ({
  onMainClick,
  dropdownOptions,
  onSelect,
  isShrunk
}) => {
  const [open, setOpen] = useState(false)

  const handleMainClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    onMainClick()
  }

  const handleDropdownToggle = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    setOpen(!open)
  }

  const handleOptionClick = (option: IDropdownOption) => {
    onSelect(option)
  }

  // Optional: Close dropdown if clicked outside
  /*   React.useEffect(() => {
    const handleClickOutside = () => setOpen(false)
    if (open) {
      window.addEventListener('click', handleClickOutside)
    }
    return () => window.removeEventListener('click', handleClickOutside)
  }, [open]) */

  return (
    <div className="combined-button-dropdown">
      <div className="main-button" onClick={handleMainClick}>
        <span className="icon">
          <img
            src={ChatIcon}
            alt="ChatIcon"
            style={{ width: 30, height: 30, paddingLeft: 6, paddingTop: 2, borderRadius: '50%' }}
          />
        </span>
        {!isShrunk && <span className="label">New Chat</span>}
      </div>

      {/* Dropdown Toggle positioned on the right */}
      <div className="dropdown-toggle" onClick={handleDropdownToggle}>
        <img
          src={DownIcon}
          style={{
            width: 20,
            height: 20,
            paddingLeft: 0,
            paddingTop: 2,
            borderRadius: '50%',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease'
          }}
        />
      </div>

      {/* Dropdown Menu */}

      {open && (
        <div className={`dropdown-menu ${open ? 'open' : ''} ${isShrunk ? 'shrunk' : ''}`}>
          <ul>
            {dropdownOptions.map((option, index) => (
              <li key={index} onClick={() => handleOptionClick(option)}>
                {option.text}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

/* type CollapsibleSidebarProps = {
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
}; */

const handleMainClick = (navigate: ReturnType<typeof useNavigate>, location: string) => {
  '/'
  if (location === '/') {
    window.location.reload()
  } else {
    navigate('/')
  }
}

const handleDropdownChange = (
  navigate: ReturnType<typeof useNavigate>,
  location: string,
  event?: React.FormEvent<HTMLDivElement>,
  option?: IDropdownOption
): void => {
  if (!option) return
  const targetPath = option.key.toString()

  if (location === targetPath) {
    window.location.reload() // 🔁 Refresh if already on this page
  } else {
    navigate(targetPath) // ✅ Navigate if it's a different route
  }
}
const handleSelect = (option: string) => {
  alert(`Selected: ${option}`)
}
/* const CollapsibleSidebar = ({ isCollapsed, setIsCollapsed }: CollapsibleSidebarProps) => {
  const [isShrunk, setIsShrunk] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const toggleSidebar = () => {
    setIsCollapsed((prev: boolean) => !prev);
    setIsShrunk((prev) => !prev);
  };

  // Sidebar width for positioning the toggle button outside the sidebar
  const sidebarWidth = isCollapsed ? 117 : 240;
  const appStateContext = useContext(AppStateContext);
  const ui = appStateContext?.state.frontendSettings?.ui;


  const renderPlaceholder = (props?: IDropdownProps) => {
    // You can access props.placeholder if needed
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',    // vertical centering
          justifyContent: 'center', // horizontal centering
          color: '#404D59',         // text color
          width: '100%',            // take full width so centering works properly
          gap: 8,                   // space between image and text
        }}
      >
        <img
          src={MenuIcon}
          alt="placeholder"
          style={{ width: 20, height: 20, borderRadius: '50%', filter: 'brightness(0) saturate(100%)' }}
        />
        <span>{props?.placeholder || 'App Explorer'}</span>
      </div>
    );
  };
  const renderPlaceholderClosed = (props?: IDropdownProps) => {
    // You can access props.placeholder if needed
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',    // vertical centering
          justifyContent: 'center', // horizontal centering
          color: '#404D59',         // text color
          width: '100%',            // take full width so centering works properly
          gap: 8,                   // space between image and text
        }}
      >
        <img
          src={MenuIcon}
          alt="placeholder"
          style={{ width: 20, height: 20, borderRadius: '50%', filter: 'brightness(0) saturate(100%)' }}
        />
        <span>{props?.placeholder || ''}</span>
      </div>
    );
  };
  // Example dropdown options
  const dropdownOptions1: IDropdownOption[] = [
    { key: 'option1', text: 'Option 1' },
    { key: 'option2', text: 'Option 2' },
  ];

  const dropdownOptions2: IDropdownOption[] = [
    { key: 'a', text: 'Choice A' },
    { key: 'b', text: 'Choice B' },
  ];
  const dropdownOptionsChat: IDropdownOption[] = [
    { key: '/', text: 'Chat' },
    { key: '/', text: 'Wizard' },
  ];
  const dropdownOptionsApps: IDropdownOption[] = [
    {
      key: '/litreview', text: 'Literature Review', data: {
        icon: LiteratureIcon,
      },
    }
  ];
  const renderOptionWithIcon = (option?: IDropdownOption) => {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {option?.data?.icon && (
          <img
            src={option.data.icon}
            alt=""
            style={{ width: 18, height: 18 }}
          />
        )}
        <span>{option?.text}</span>
      </div>
    );
  }; */

/* return (
    <> */
{
  /* Toggle Button always outside the sidebar */
}
{
  /*<button
        onClick={toggleSidebar}
        style={{
          position: 'fixed',
          top: 16,
          left: sidebarWidth - 2, // 8px gap outside sidebar
          zIndex: 1001,
          backgroundColor: '#EAEFF9', // same as sidebar bg color
          color: '#2c3e50', // dark text for contrast
          border: 'none',
          borderRadius: 4,
          padding: '6px 10px',
          fontSize: 18,
          cursor: 'pointer',
          transition: 'left 0.3s ease',
          userSelect: 'none',
          width: 36,
          height: 36,
        }}
        aria-label="Toggle Sidebar"
      >
        <img
          src={isCollapsed ? RightIcon : LeftIcon}
          alt="icon"
          style={{ width: 20, height: 20, filter: 'brightness(0) saturate(100%)' }}
        />
      </button>*/
}

{
  /* Sidebar */
}
{
  /*<div
        style={{
          width: sidebarWidth,
          height: '100vh',
          backgroundColor: '#EAEFF9',
          transition: 'width 0.3s ease',
          position: 'fixed',
          top: 0,
          left: 0,
          overflow: 'visible',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '16px',
          boxSizing: 'border-box',
          zIndex: 1000,
        }}
      >*/
}
{
  /* Logo + Title */
}
{
  /*<div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 24 }}>
          <img src={ETF} alt="ETF" style={{ width: 50, height: 38 }} />
          {!isCollapsed && (
            <h1
              className={styles.headerTitle}
              style={{ marginLeft: 20, margin: 0, lineHeight: '38px' }}
            >
              {ui?.title.toUpperCase()}
            </h1>
          )}

        </div>/*}

        {/* Dropdowns */
}
{
  /*{!isCollapsed && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}>
            <CombinedButtonDropdown
              onMainClick={() => handleMainClick(navigate, location.pathname)}
              dropdownOptions={dropdownOptionsChat}
              onSelect={(option) => handleDropdownChange(navigate, location.pathname, undefined, option)}
              isShrunk={isCollapsed}
            />
            <Dropdown
              placeholder="App explorer"
              options={dropdownOptionsApps}
              onRenderPlaceholder={renderPlaceholder}
              onRenderOption={renderOptionWithIcon}
              styles={{
                ...customDropdownStylesSidebar,
                root: { width: '180px', height: '40px' },
              }}
              onChange={(event, option) =>
                handleDropdownChange(navigate, location.pathname, event, option)}
            >
            </Dropdown>
          </div>
        )}{isCollapsed && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}>
            <CombinedButtonDropdown
              onMainClick={() => handleMainClick(navigate, location.pathname)}
              dropdownOptions={dropdownOptionsChat}
              onSelect={(option) => handleDropdownChange(navigate, location.pathname, undefined, option)}
              isShrunk={isCollapsed}
            />
            <Dropdown
              placeholder=""
              options={dropdownOptionsApps}
              onRenderPlaceholder={renderPlaceholderClosed}
              styles={{
                ...customDropdownStylesSidebar,
                root: { width: '90px', height: '40px' },
              }}
              onChange={(event, option) =>
                handleDropdownChange(navigate, location.pathname, event, option)}
            >
            </Dropdown></div>)}
      </div>*/
}
/* </>
  );
}; */

const LitReview = () => {
  const appStateContext = useContext(AppStateContext)
  const stopwords = ['the','to', 'a', 'an', 'and', 'or', 'but', 'of', 'in', 'on', 'for', 'with']
  const countryList = appStateContext?.state.countryList
  //const activeStep = 0;
  const [isDownloadOpen, setIsDownloadOpen] = useState(false)
  const [query, setQuery] = useState('')
  const [formatedQuery, setFormatedQuery] = useState('')
  const [activeStep, setactiveStep] = useState(0)
  const [lastConcludedStep, setLastConcludedStep] = useState(0)
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false)

  const [isRestartHovered, setIsRestartHovered] = useState(false)
  const [isFilterHovered, setIsFilterHovered] = useState(false)
  const [upperValue, setUpperValue] = React.useState(new Date().getFullYear())
  const [lowerValue, setLowerValue] = React.useState(2000)
  const [selectedCountriesOptions, setSelectedCountriesOptions] = useState<IDropdownOption[]>([])
  const [selectedSourceOptions, setSelectedSourceOptions] = useState<IDropdownOption[]>([])
  const [selectedDocTypeOptions, setSelectedDocTypeOptions] = useState<IDropdownOption[]>([])

  //Loading and error states
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  // Articles
  const [articles, setArticles] = useState<Article[]>([])
  const [selectedDocButtons, setSelectedDocButtons] = useState<Record<string, boolean>>({})
  const trueDocCount = Object.values(selectedDocButtons).filter(Boolean).length
  const docCount = articles.length
  const uniqueSources: IDropdownOption[] = [
    ...new Set(articles.map(a => a.source).filter((t): t is string => !!t))
  ].map(source => ({
    key: source,
    text: source
  }))

  const [selectedSourcesFilter, setSelectedSourcesFilter] = useState<string[]>([])
  const [openArticle, setOpenArticle] = useState<Article | null>(null)
  const [isArticleOpened, setIsArticleOpened] = useState<boolean>(false)

  //Keywords possible not complete
  const [keywords, setKeywords] = useState<string[]>([])
  const [customKeyword, setcustomKeyword] = useState('')
  const [selectedButtons, setSelectedButtons] = useState<boolean[]>([])
  const [keywordSelection, setKeywordSelection] = useState('')
  const trueCount = selectedButtons.filter(Boolean).length

  //LitReview Output
  type LitReviewDoc = {
    title: string
    corpus: string
  }
  const [litreviewDoc, setLitReviewDoc] = useState<LitReviewDoc[]>([])
  const [litReviewData, setLitReviewData] = useState<LitReviewOutput | null>(null)

  const handleKeywords = async (formattedQuery: string) => {
    setLoading(true)
    //await wait(10000); // waits 1 second
    setError('')

    try {
      // Keep the selected keywords
      const selectedKeywords = keywords.filter((_, i) => selectedButtons[i]).filter(kw => kw.trim().length > 0)

      let result: string[] | null = []

      // Fetch new keywords from the server
      if (selectedKeywords.length === 0) {
        result = await fetchLitReviewKeywords(formattedQuery)
      } else {
        result = await fetchLitReviewKeywords(formattedQuery, selectedKeywords.join(';'))
      }

      console.log(selectedKeywords.join(';'))

      if (!result || result.length === 0) {
        setError('Could not fetch keywords.')
        return
      }

      // Start with the selected keywords
      const newKeywords = [...selectedKeywords]

      // Fill in until total length is selectedKeywords.length + 10
      for (let i = 0; i < result.length && newKeywords.length < selectedKeywords.length + 10; i++) {
        const kw = result[i]
        if (!newKeywords.includes(kw)) {
          newKeywords.push(kw)
        }
      }

      // Enforce exact length of selected + 10
      if (newKeywords.length > selectedKeywords.length + 10) {
        newKeywords.length = selectedKeywords.length + 10
      }

      setKeywords(newKeywords)

      // Update selected buttons
      const newSelectedButtons = newKeywords.map(kw => selectedKeywords.includes(kw))
      setSelectedButtons(newSelectedButtons)
    } catch (err) {
      setError('Error fetching keywords.')
    } finally {
      setLoading(false)
    }
  }

  const addKeyword = (newKeyword: string) => {
    const trimmed = newKeyword.trim()
    if (!trimmed) return // ignore empty input

    setKeywords(prevKeywords => [trimmed, ...prevKeywords]) // new keyword first
    setSelectedButtons(prevSelected => [true, ...prevSelected]) // selected by default
    setLastConcludedStep(1)
    setcustomKeyword('') // clear input field
  }

  const handleLabelChange = (index: number, newLabel: string) => {
    setKeywords(prev => {
      const updated = [...prev]
      updated[index] = newLabel
      return updated
    })
  }

  const downloadOptions = [
    { label: 'Word', value: 'word', icon: WordIcon },
    { label: 'CSV', value: 'csv', icon: CSVIcon }
  ]
  const generateQuery = async () => {
    //Uncomment to add countries
    const formatted = query + ' in ' + selectedCountriesOptions.map(o => o.text).join(', ') + '.'
    setFormatedQuery(formatted) // still update state if needed
    return formatted
  }
  const handleCountryDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
    if (!option) return

    deselectAllButtons(keywords.length)
    setLastConcludedStep(0)
    resetKeywords()

    setSelectedCountriesOptions(prev => {
      if (option.selected) {
        // Add selected option
        return [...prev, option]
      } else {
        // Remove unselected option
        return prev.filter(o => o.key !== option.key)
      }
    })
  }

  const handleSourceDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
    if (!option) return

    deselectAllButtons(keywords.length)
    setLastConcludedStep(0)
    resetKeywords()
    setSelectedSourceOptions(prev => {
      if (option.selected) {
        // Add selected option
        return [...prev, option]
      } else {
        // Remove unselected option
        return prev.filter(o => o.key !== option.key)
      }
    })
  }

  const dropdownSourceOptionsWithAll = withSelectAllOption(dropdownSourcesOptions)

  const dropdownSourceSelectedKeys = getSelectedKeysWithAll(selectedSourceOptions, dropdownSourcesOptions)

  const handleDocTypeDropdownChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption): void => {
    if (!option) return

    deselectAllButtons(keywords.length)
    setLastConcludedStep(0)
    resetKeywords()
    setSelectedDocTypeOptions(prev => {
      if (option.selected) {
        // Add selected option
        return [...prev, option]
      } else {
        // Remove unselected option
        return prev.filter(o => o.key !== option.key)
      }
    })
  }

  const docTypeDropdownWithAll = withSelectAllOption(dropdownDocTypesOptions)

  const docTypesKeysWithAll = getSelectedKeysWithAll(selectedDocTypeOptions, dropdownDocTypesOptions)

  const handleSelectionChange = (index: number, newValue: boolean) => {
    const updated = [...selectedButtons]
    updated[index] = newValue
    setSelectedButtons(updated)
    setLastConcludedStep(1)
  }

  const selectAllButtons = (length: number) => {
    setSelectedButtons(Array(length).fill(true)) // Set all to true
    setLastConcludedStep(1)
  }
  const deselectAllButtons = (length: number) => {
    setSelectedButtons(Array(length).fill(false)) // Set all to false
    setLastConcludedStep(1)
  }

  const resetKeywords = () => {
    setKeywords([])
    setSelectedButtons([])
    setLastConcludedStep(0)
  }

  const docselectAllButtons = () => {
    const updated: Record<string, boolean> = {}

    articles.forEach(article => {
      updated[article.id] = true
    })

    setSelectedDocButtons(updated)
  }
  const docdeselectAllButtons = () => {
    const updated: Record<string, boolean> = {}

    articles.forEach(article => {
      updated[article.id] = false
    })

    setSelectedDocButtons(updated)
  }

  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      selectAllButtons(keywords.length) // Select all if the checkbox is checked
      docdeselectAllButtons() // Deselect all documents when selecting all keywords
      setLastConcludedStep(1)
    } else {
      deselectAllButtons(keywords.length) // Deselect all if the checkbox is unchecked
      docdeselectAllButtons()
      setLastConcludedStep(1)
    }
  }

  //DOC Buttons
  const dochandleSelectionChange = (id: string, newValue: boolean) => {
    setSelectedDocButtons(prev => ({
      ...prev,
      [id]: newValue
    }))
  }

  const dochandleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      docselectAllButtons() // Select all if the checkbox is checked
    } else {
      docdeselectAllButtons() // Deselect all if the checkbox is unchecked
    }
  }

  //END DOC Buttons

  const buttons = Array.from({ length: keywords.length }, (_, i) => (
    <div key={i}>
      <KeywordButton
        label={keywords[i]}
        isSelected={selectedButtons[i]}
        onSelectionChange={newSelection => {
          handleSelectionChange(i, newSelection)
        }}
        onLabelChange={newLabel => handleLabelChange(i, newLabel)}
      />
    </div>
  ))

  const docbuttons = Array.from(
    articles
      .filter(article => {
        // Show all if nothing is selected
        if (selectedSourcesFilter.length === 0) return true
        // Only show if source is in selectedSourcesFilter
        return selectedSourcesFilter.includes(article.source as string)
      })
      .map((article, i) => (
        <div key={i}>
          <DocumentButton
            label={article.title}
            abstract={article.abstract || 'No abstract available'}
            article={article}
            isSelected={!!selectedDocButtons[article.id]}
            onSelectionChange={newSelection => {
              dochandleSelectionChange(article.id, newSelection)
              setLastConcludedStep(2)
              setLitReviewDoc([])
            }}
            setArticle={setOpenArticle}
            setIsArticleOpened={setIsArticleOpened}
          />
        </div>
      ))
  )

  const countryOptions = useMemo<IDropdownOption<string>[]>(() => {
    if (!countryList || !Array.isArray(countryList)) return []

    return countryList
      .filter(value => value !== 'All Countries')
      .map(value => ({
        key: value,
        text: value
      }))
  }, [countryList])

  const countryOptionsWithAll = withSelectAllOption(countryOptions)

  const countrySelectedKeys = getSelectedKeysWithAll(selectedCountriesOptions, countryOptions)

  const handleFetchArticles = async (
    setArticles: React.Dispatch<React.SetStateAction<Article[]>>,
    setLoading: React.Dispatch<React.SetStateAction<boolean>>,
    setError: React.Dispatch<React.SetStateAction<string>>,
    keywords: string,
    StartDate: string,
    EndDate: string,
    language: string,
    documentType: string,
    sources: string[]
  ) => {
    setLoading(true)
    setError('')
    setArticles([])
    console.log('Keywords:', keywords)
    try {
      const params: GetArticlesParams = {
        keywords: keywords,
        start_date: StartDate,
        end_date: EndDate,
        language: language,
        document_type: documentType,
        sources: sources
      }

      const result = await fetchArticles(params)
      const flatResult: Article[] = (result as any[]).flat()
      setArticles(flatResult)
      console.log(flatResult)
    } catch (err: any) {
      setError(err.message || 'Failed to fetch articles')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center', // ✅ CENTER horizontally
        alignItems: 'flex-start',
        minWidth: '50%',
        maxWidth: '90%',
        paddingRight: 20
      }}>
      {/* Sidebar wrapper with fixed width */}
      {/* <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          height: '100vh',
          paddingTop: 30,
          paddingLeft: 40,
          zIndex: 10
        }}> */}
      {/* Sidebar */}
      {/* <div style={{ transition: 'width 0.3s ease', width: isCollapsed ? 60 : 200 }}>
          <CollapsibleSidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
        </div> */}

      {/* Step Section (responsive to sidebar) */}

      {false && (
        <button
          onClick={() => console.log('Help clicked')}
          style={{
            position: 'fixed',
            top: 24,
            right: 24,
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            zIndex: 2000
          }}>
          <img src={HelpIcon} alt="Help" style={{ width: 36, height: 36 }} />
        </button>
      )}

      {/* Main Content */}
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ width: 400, paddingLeft: 180 }}>
          {/* Title and Icon */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              marginBottom: 24,
              color: '#303133',
              fontSize: 20,
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 'bold'
            }}>
            <img src={LiteratureIcon} alt="LiteratureIcon" style={{ width: 24, height: 24 }} />
            Literature Review
          </div>

          {/* Steps Layout */}
          <div style={{ display: 'flex', flexDirection: 'row', paddingTop: '15px' }}>
            {/* Dots */}
            <div style={{ paddingTop: '20px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 12 }}>
                {steps.map((_, index) => (
                  <React.Fragment key={index}>
                    <img src={index === activeStep ? DotFilled : Dot} alt="dot" style={{ width: 25, height: 25 }} />
                    {index < steps.length - 1 && <div style={{ width: 2, height: 47, backgroundColor: '#C0C0C0' }} />}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Step Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {steps.map((step, index) => {
                const stepIcons = [SearchIcon, IdeaIcon, LibraryIcon, ParagraphIcon]
                const stepIcon = stepIcons[index % stepIcons.length]
                const stepIconColors = [
                  'invert(43%) sepia(94%) saturate(1561%) hue-rotate(169deg) brightness(96%) contrast(102%)',
                  'invert(40%) sepia(11%) saturate(334%) hue-rotate(174deg) brightness(92%) contrast(90%)'
                ]

                return (
                  <button
                    onClick={() => {
                      if (index <= lastConcludedStep) {
                        setactiveStep(index)
                      }
                      console.log(index < lastConcludedStep)
                    }}
                    key={index}
                    style={{
                      width: 150,
                      height: 60,
                      borderRadius: 12,
                      border: 'none',
                      textAlign: 'left',
                      padding: '10px 16px',
                      backgroundColor: index === activeStep ? '#fff' : '#f5f7fa',
                      color: '#2c3e50',
                      boxShadow: index === activeStep ? '0 0 6px rgba(0,0,0,0.1)' : 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      fontFamily: 'Montserrat, sans-serif',
                      fontWeight: index === activeStep ? 'bold' : 400
                    }}>
                    <img
                      src={stepIcon}
                      alt="icon"
                      style={{
                        width: 24,
                        height: 24,
                        filter: index <= lastConcludedStep ? stepIconColors[0] : stepIconColors[1]
                      }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span style={{ fontSize: 12, color: '#6c7a89' }}>Step {index + 1}</span>
                      <div style={{ fontSize: 14 }}>{step.label}</div>
                    </div>
                  </button>
                )
              })}
            </div>
          </div>
        </div>
        {activeStep == 0 && (
          <div
            style={{
              top: '35px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
              transition: 'all 300ms ease-in-out'
            }}>
            <Stack
              tokens={{ childrenGap: 20 }}
              styles={{
                root: {
                  width: '100%',
                  maxWidth: 1200,
                  padding: '0 60px',
                  boxSizing: 'border-box',
                  margin: '0 auto' // ✅ centers content horizontally
                }
              }}>
              <div
                style={{
                  width: 406,
                  height: 24,
                  textAlign: 'center',
                  color: '#303133',
                  fontSize: '20px',
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 800, // Increase fontWeight for heavier boldness
                  fontStyle: 'normal', // Keep this normal unless italic is needed
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  opacity: 1,
                  margin: '0 auto',
                  marginBottom: 24
                }}>
                Research definition
              </div>
              <div
                style={{
                  width: 700,
                  height: 51,
                  textAlign: 'justify',
                  color: '#677179',
                  fontSize: 14,
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  fontStyle: 'regular',
                  lineHeight: '100%',
                  letterSpacing: 0,
                  opacity: 1,
                  margin: '0 auto', // Center horizontally
                  wordWrap: 'break-word',
                  marginBottom: 24
                }}>
                Fill in the inputs by defining the general information and selecting the time range. This will help
                filter the keywords that will be generated in the next step. Make sure the details are accurate and the
                time range align with your needs, ensuring the generated keywords are relevant and precise.
              </div>

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32 }}>
                {/*here*/}
                <TextField
                  multiline
                  placeholder="Insert topic description or select one of the examples below..."
                  styles={customTextFieldStyles}
                  value={query}
                  onChange={(e, newValue) => {
                    setQuery(newValue || '')
                    setLastConcludedStep(0)
                    deselectAllButtons(keywords.length)
                    resetKeywords()
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault()
                    }
                  }}
                />
              </div>

              <div
                style={{
                  width: 620,
                  margin: '0 auto', // Centers the container horizontally
                  display: 'flex',
                  justifyContent: 'flex-start',
                  gap: 20,
                  marginTop: 16,
                  opacity: 1,
                  marginBottom: 24
                }}></div>

              <div style={{ width: 660, margin: '0 auto', marginTop: 40 }}>
                <Stack
                  horizontal
                  tokens={{ childrenGap: 32 }}
                  horizontalAlign="space-between"
                  verticalAlign="center"
                  styles={{ root: { width: '100%' } }}>
                  <Dropdown
                    label="Countries"
                    placeholder="Select countries"
                    multiSelect
                    options={countryOptionsWithAll}
                    selectedKeys={countrySelectedKeys}
                    styles={{
                      ...customDropdownStyles,
                      root: { width: dropdownWidth },
                      callout: { height: 300 }
                    }}
                    onChange={(e, option) =>
                      handleMultiSelectChange(
                        option,
                        selectedCountriesOptions,
                        countryOptions,
                        setSelectedCountriesOptions,
                        resetKeywords
                      )
                    }
                    onRenderTitle={selectedOptions => {
                      const realOptions = selectedOptions?.filter(opt => opt.key !== SELECT_ALL_KEY) || []

                      const allSelected = realOptions.length === countryOptions.length

                      if (allSelected) {
                        return <span>All</span>
                      }

                      return <span>{realOptions.map(opt => opt.text).join(', ')}</span>
                    }}
                  />
                  <Dropdown
                    label="Document types"
                    placeholder="Select types"
                    multiSelect
                    options={docTypeDropdownWithAll}
                    selectedKeys={docTypesKeysWithAll}
                    styles={{
                      ...customDropdownStyles,
                      root: { width: dropdownWidth }
                    }}
                    onChange={(e, option) =>
                      handleMultiSelectChange(
                        option,
                        selectedDocTypeOptions,
                        dropdownDocTypesOptions,
                        setSelectedDocTypeOptions,
                        resetKeywords
                      )
                    }
                    onRenderTitle={selectedOptions => {
                      const realOptions = selectedOptions?.filter(opt => opt.key !== SELECT_ALL_KEY) || []

                      const allSelected = realOptions.length === dropdownDocTypesOptions.length

                      if (allSelected) {
                        return <span>All</span>
                      }

                      return <span>{realOptions.map(opt => opt.text).join(', ')}</span>
                    }}
                  />
                </Stack>
              </div>

              <div style={{ width: 660, margin: '0 auto' }}>
                <Stack
                  horizontal
                  tokens={{ childrenGap: 32 }}
                  horizontalAlign="space-between"
                  verticalAlign="center"
                  styles={{ root: { width: '100%' } }}>
                  <Dropdown
                    label="Sources"
                    placeholder="Select sources"
                    multiSelect
                    options={dropdownSourceOptionsWithAll}
                    selectedKeys={dropdownSourceSelectedKeys}
                    onChange={(e, option) =>
                      handleMultiSelectChange(
                        option,
                        selectedSourceOptions,
                        dropdownSourcesOptions,
                        setSelectedSourceOptions,
                        resetKeywords
                      )
                    }
                    onRenderTitle={selectedOptions => {
                      const realOptions = selectedOptions?.filter(opt => opt.key !== SELECT_ALL_KEY) || []

                      const allSelected = realOptions.length === dropdownSourcesOptions.length

                      if (allSelected) {
                        return <span>All</span>
                      }

                      return <span>{realOptions.map(opt => opt.text).join(', ')}</span>
                    }}
                    styles={{
                      ...customDropdownStyles,
                      root: { width: dropdownWidth },
                      callout: { height: 300 }
                    }}
                  />
                  <Slider
                    label="Time range"
                    min={2000}
                    max={new Date().getFullYear()}
                    step={1}
                    ranged
                    value={upperValue}
                    lowerValue={lowerValue}
                    showValue
                    styles={sliderStyles}
                    onChange={(event, range) => {
                      deselectAllButtons(keywords.length)
                      setLastConcludedStep(0)
                      resetKeywords()
                      if (range) {
                        setUpperValue(range[1])
                        setLowerValue(range[0])
                      }
                    }}
                  />
                </Stack>
              </div>

              <Stack tokens={{ childrenGap: 10 }}></Stack>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                <PrimaryButton
                  text="Next step"
                  styles={nextStepButtonStyles}
                  onClick={async () => {
                    console.log(lastConcludedStep)
                    setactiveStep(activeStep + 1)
                    if (lastConcludedStep < 1) {
                      setLastConcludedStep(1)
                      const generatedQuery = await generateQuery()
                      await handleKeywords(generatedQuery)
                    }
                  }}
                  disabled={
                    query.trim() === '' ||
                    selectedCountriesOptions.length === 0 ||
                    selectedSourceOptions.length === 0 ||
                    selectedDocTypeOptions.length === 0
                  }
                />
              </div>
            </Stack>
          </div>
        )}
        {activeStep == 1 && (
          <div
            style={{
              top: '35px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
              transition: 'all 300ms ease-in-out'
            }}>
            <Stack
              tokens={{ childrenGap: 20 }}
              styles={{
                root: {
                  width: '100%',
                  maxWidth: 1200,
                  padding: '0 60px',
                  boxSizing: 'border-box',
                  margin: '0 auto' // ✅ centers content horizontally
                }
              }}>
              <div
                style={{
                  width: 406,
                  height: 24,
                  textAlign: 'center',
                  color: '#303133',
                  fontSize: '20px',
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 800, // Increase fontWeight for heavier boldness
                  fontStyle: 'normal', // Keep this normal unless italic is needed
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  opacity: 1,
                  margin: '0 auto',
                  marginBottom: 24
                }}>
                Keywords definition
              </div>
              <div
                style={{
                  width: 700,
                  height: 51,
                  textAlign: 'justify',
                  color: '#677179',
                  fontSize: 14,
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  fontStyle: 'regular',
                  lineHeight: '100%',
                  letterSpacing: 0,
                  opacity: 1,
                  margin: '0 auto', // Center horizontally
                  wordWrap: 'break-word',
                  marginBottom: 10
                }}>
                Adjust the selection of keywords to filter the references generated in the next step. You can refine the
                keywords by choosing those most relevant to your needs. If desired, use the provided input field to
                create and add a new keyword to furhter tailor the results.
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center', // ✅ this line centers content vertically
                  marginTop: 10,
                  gap: 10 // optional: adds spacing between items
                }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <TextField
                    multiline
                    placeholder="Insert new keyword..."
                    styles={customTextFieldStylesSmall}
                    value={customKeyword}
                    onChange={(_, newValue) => setcustomKeyword(newValue || '')}
                    onKeyDown={e => {
                      if (e.key === 'Enter' && !e.shiftKey) {
                        e.preventDefault()
                        if (customKeyword.trim()) {
                          addKeyword(customKeyword)
                        }
                      }
                    }}
                    onRenderSuffix={() => (
                      <button
                        onClick={() => {
                          if (customKeyword.trim()) {
                            addKeyword(customKeyword)
                          }
                        }}
                        style={{
                          backgroundColor: '#009CDA', // bright blue circle background
                          border: 'none',
                          borderRadius: '50%', // makes it circular
                          width: 32,
                          height: 32,
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: 0
                        }}
                        aria-label="Add keyword">
                        <img
                          src={PlusIcon}
                          alt="PlusIcon"
                          style={{
                            width: 20,
                            height: 20,
                            borderRadius: '50%'
                          }}
                        />
                      </button>
                    )}
                  />
                </div>

                <PrimaryButton
                  onClick={() => {
                    handleKeywords(formatedQuery)
                    console.log(keywords.length)
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#404D59',
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center', // ✅ centers text with icon
                    padding: 0
                  }}>
                  <img
                    src={RefreshIcon}
                    alt="icon"
                    style={{
                      filter: 'brightness(0) saturate(100%)',
                      paddingRight: 3,
                      width: 16,
                      height: 16
                    }}
                  />
                  <span style={{ fontSize: 14, fontFamily: 'Montserrat, sans-serif', color: '#404D59' }}>Refresh</span>
                </PrimaryButton>

                <input
                  type="checkbox"
                  checked={selectedButtons.every(isSelected => isSelected)} // Check if all are selected
                  onChange={handleSelectAllChange}
                />

                <div
                  style={{
                    fontSize: 14,
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#404D59',
                    paddingLeft: 2
                  }}>
                  Select all
                </div>

                <div
                  style={{
                    fontSize: 14,
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#677179',
                    paddingLeft: 8,
                    width: '150px',
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap'
                  }}>
                  {' '}
                  <span style={{ display: 'inline-block', width: '100px', textAlign: 'right' }}>
                    {trueCount}/{keywords.length} selected
                  </span>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '12px',
                    //maxWidth: 800, Optional, adjust as needed
                    margin: '0 auto',
                    height: '340px',
                    overflowY: 'auto' // Enable vertical scrolling if needed
                  }}>
                  {loading && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%', // or e.g. '50px' if you want a fixed height container
                        gap: '8px', // optional spacing between image and text
                        boxSizing: 'border-box'
                      }}>
                      <style>
                        {`
                    @keyframes spin {
                      from { transform: rotate(0deg); }
                      to { transform: rotate(-360deg); }
                  }
                `}
                      </style>
                      <img
                        src={RefreshIcon}
                        alt="ChatIcon"
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite', // 👈 spinning effect
                          filter:
                            'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)',
                          transformOrigin: 'center' // center of 30x30 image
                        }}
                      />
                      <span>
                        <div
                          style={{
                            fontFamily: 'Montserrat, sans-serif',
                            color: '#677179'
                          }}>
                          Loading keywords...{' '}
                        </div>
                      </span>
                    </div>
                  )}
                  {!loading && buttons}
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <PrimaryButton
                    text="Previous step"
                    styles={previousStepButtonStyles}
                    onClick={() => {
                      setactiveStep(activeStep - 1)
                    }}
                  />
                  <PrimaryButton
                    text="Next step"
                    disabled={trueCount === 0}
                    styles={nextStepButtonStyles}
                    onClick={() => {
                      setIsArticleOpened(false)
                      if (lastConcludedStep < 2) {
                        // Build keywords part
                        const keywordString = keywords
                          .filter((_, index) => selectedButtons[index]) // only selected
                          .map(k => k.trim())
                          .map(k =>
                            k
                              .split(/\s+/)
                              .filter(word => !stopwords.includes(word.toLowerCase()))
                              .join('+')
                          )
                          .join('+')

                        setKeywordSelection(keywordString.replaceAll('+', '; '))

                        // Build countries part (check missing ones)
                        //const countryValues = selectedCountriesOptions.map(opt => opt.text.trim().replace(/\s+/g, '+')) // assume IDropdownOption has "text" or "label"

                        // Ensure no duplicates (merge)
                        //const combined = new Set([...keywordString.split('+').filter(Boolean), ...countryValues])

                        // Final string
                        //const finalString = Array.from(combined).join('+')
                        const finalString = keywordString.split('+').filter(Boolean).join('+')

                        setLastConcludedStep(2)
                        setArticles([])
                        handleFetchArticles(
                          setArticles,
                          setLoading,
                          setError,
                          finalString,
                          lowerValue.toString(),
                          upperValue.toString(),
                          'en',
                          selectedDocTypeOptions[0].key as string,
                          selectedSourceOptions.map((opt: IDropdownOption<any>) => opt.key as string)
                        )
                      }
                      setactiveStep(activeStep + 1)
                    }}
                  />
                </div>
              </div>
            </Stack>
          </div>
        )}
        {activeStep == 2 && (
          <div
            style={{
              top: '35px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
              transition: 'all 300ms ease-in-out'
            }}>
            <Stack
              tokens={{ childrenGap: 20 }}
              styles={{
                root: {
                  width: '100%',
                  maxWidth: 1200,
                  padding: '0 60px',
                  boxSizing: 'border-box',
                  margin: '0 auto' // ✅ centers content horizontally
                }
              }}>
              <div
                style={{
                  width: 406,
                  height: 24,
                  textAlign: 'center',
                  color: '#303133',
                  fontSize: '20px',
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 800, // Increase fontWeight for heavier boldness
                  fontStyle: 'normal', // Keep this normal unless italic is needed
                  lineHeight: '100%',
                  letterSpacing: '0%',
                  opacity: 1,
                  margin: '0 auto',
                  marginBottom: 24
                }}>
                References definition
              </div>
              <div
                style={{
                  width: 700,
                  height: 51,
                  textAlign: 'justify',
                  color: '#677179',
                  fontSize: 14,
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  fontStyle: 'regular',
                  lineHeight: '100%',
                  letterSpacing: 0,
                  opacity: 1,
                  margin: '0 auto', // Center horizontally
                  wordWrap: 'break-word',
                  marginBottom: 0
                }}>
                Adjust the selection of references to filter the final generated file. Choose the references that best
                match your needs. If necessary, use the provided field to add a new reference, further customizing the
                final output to ensure it aligns with your specific requirements.
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                <Dropdown
                  placeholder="All Sources"
                  multiSelect
                  options={uniqueSources}
                  selectedKeys={selectedSourcesFilter} // ✅ Controlled selection
                  styles={{
                    ...customDropdownStylesStep3,
                    root: { width: '200px' }
                  }}
                  onChange={(event, option) => {
                    if (!option) return

                    const newSelectedKeys = option.selected
                      ? [...selectedSourcesFilter, option.key as string]
                      : selectedSourcesFilter.filter(key => key !== option.key)

                    setSelectedSourcesFilter(newSelectedKeys)
                  }}
                />
                {/* <Dropdown
                  placeholder="All Reference Levels"
                  multiSelect
                  options={dropdownOptions}
                  styles={{
                    ...customDropdownStylesStep3,
                    root: { width: '200px' }
                  }}
                /> */}
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: 10,
                  gap: 10
                }}>
                <PrimaryButton
                  style={{
                    background: 'none',
                    border: 'none',
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#404D59',
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    padding: 0
                  }}>
                  <img
                    src={RefreshIcon}
                    alt="icon"
                    style={{
                      filter: 'brightness(0) saturate(100%)',
                      paddingRight: 3,
                      width: 16,
                      height: 16
                    }}
                  />
                  <span style={{ fontSize: 14, fontFamily: 'Montserrat, sans-serif', color: '#404D59' }}>Refresh</span>
                </PrimaryButton>

                <input
                  type="checkbox"
                  checked={trueDocCount === docbuttons.length} // Check if all are selected
                  onChange={e => {
                    console.log(selectedDocButtons.length)
                    console.log()
                    dochandleSelectAllChange(e)
                  }}
                />

                <div
                  style={{
                    fontSize: 14,
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#404D59',
                    paddingLeft: 2
                  }}>
                  Select all
                </div>

                <div
                  style={{
                    fontSize: 14,
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#677179',
                    paddingLeft: 8,
                    width: '150px',
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap'
                  }}>
                  {' '}
                  <span style={{ display: 'inline-block', width: '100px', textAlign: 'right' }}>
                    {trueDocCount}/{docCount} selected
                  </span>
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr',
                    gap: '12px',
                    margin: '0 auto',
                    height: '350px', // Set the max height as needed
                    overflowY: 'auto' // Enables vertical scrolling
                  }}>
                  {loading && (
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%', // or e.g. '50px' if you want a fixed height container
                        gap: '8px', // optional spacing between image and text
                        boxSizing: 'border-box'
                      }}>
                      <style>
                        {`
                    @keyframes spin {
                      from { transform: rotate(0deg); }
                      to { transform: rotate(-360deg); }
                  }
                `}
                      </style>
                      <img
                        src={RefreshIcon}
                        alt="ChatIcon"
                        style={{
                          width: 30,
                          height: 30,
                          borderRadius: '50%',
                          animation: 'spin 1s linear infinite', // 👈 spinning effect
                          filter:
                            'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)',
                          transformOrigin: 'center' // center of 30x30 image
                        }}
                      />
                      <span>
                        <div
                          style={{
                            fontFamily: 'Montserrat, sans-serif',
                            color: '#677179'
                          }}>
                          Fetching Documents...{' '}
                        </div>
                      </span>
                    </div>
                  )}
                  {!loading && docbuttons}
                </div>
              </div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center'
                  }}>
                  <PrimaryButton
                    text="Previous step"
                    styles={previousStepButtonStyles}
                    onClick={() => {
                      setactiveStep(activeStep - 1)
                    }}
                  />
                  <PrimaryButton
                    text="Next step"
                    styles={nextStepButtonStyles}
                    disabled={trueDocCount === 0}
                    onClick={() => {
                      setactiveStep(activeStep + 1)

                      if (lastConcludedStep < 3) {
                        setIsArticleOpened(false)
                        setLastConcludedStep(3)
                        setLoading(true)
                        fetchLitReview({
                          papers: articles.filter(article => selectedDocButtons[article.id]),
                          query
                        }).then(litreview => {
                          console.log(litreview)
                          setLitReviewData(litreview)
                          let output = [
                            { title: 'Introduction', corpus: litreview.intro },
                            { title: 'Context', corpus: litreview.context }
                          ]
                          output = [
                            ...output,
                            ...litreview.summaries.map(summary => {
                              const [titlePart, corpusPart] = summary.split('######')
                              return {
                                title: titlePart.trim(),
                                corpus: corpusPart?.trim() || ''
                              }
                            })
                          ]

                          output = [...output, { title: 'Conclusion', corpus: litreview.conclusion }]

                          output = [
                            ...output,
                            {
                              title: 'Bibliography',
                              corpus: litreview.bib.map(item => `• ${item}`).join('\n')
                            }
                          ]

                          setLitReviewDoc(output)
                          setLoading(false)
                        })
                      }
                    }}
                  />
                </div>
              </div>
            </Stack>
          </div>
        )}

        {activeStep == 3 && (
          <div
            style={{
              top: '35px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxSizing: 'border-box',
              transition: 'all 300ms ease-in-out'
            }}>
            <Stack
              tokens={{ childrenGap: 20 }}
              styles={{
                root: {
                  width: '100%',
                  maxWidth: 1200,
                  padding: '0 60px',
                  boxSizing: 'border-box',
                  margin: '0 auto' // ✅ centers content horizontally
                }
              }}>
              {/* Title */}
              <div
                style={{
                  width: 406,
                  height: 24,
                  textAlign: 'center',
                  color: '#303133',
                  fontSize: '20px',
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 800,
                  lineHeight: '100%',
                  margin: '0 auto',
                  marginBottom: 24
                }}>
                Review
              </div>

              {/* Description */}
              <div
                style={{
                  width: 700,
                  height: 51,
                  textAlign: 'justify',
                  color: '#677179',
                  fontSize: 14,
                  fontFamily: 'Montserrat, sans-serif',
                  fontWeight: 400,
                  lineHeight: '100%',
                  margin: '0 auto',
                  marginBottom: 10
                }}>
                This document is the final result of all the applied filters, keyword selections, and reference
                selections. It reflects the cumulative choices made throughout the process, ensuring that the content is
                precisely tailored to your specifications. Each element in this document has been carefully curated
                based on the inputs and adjustments you provided, making it a highly customized and targeted output.
              </div>

              {/* Main Content Row: Scrollable + Buttons */}
              <div style={{ display: 'flex', width: '100%' }}>
                {/* Scrollable Content */}
                {loading && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%', // or e.g. '50px' if you want a fixed height container
                      gap: '8px', // optional spacing between image and text
                      boxSizing: 'border-box',
                      paddingTop: '200px',
                      paddingBottom: '200px'
                    }}>
                    <style>
                      {`
                    @keyframes spin {
                      from { transform: rotate(0deg); }
                      to { transform: rotate(-360deg); }
                  }
                `}
                    </style>
                    <img
                      src={RefreshIcon}
                      alt="ChatIcon"
                      style={{
                        width: 30,
                        height: 30,
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite', // 👈 spinning effect
                        filter:
                          'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)',
                        transformOrigin: 'center' // center of 30x30 image
                      }}
                    />
                    <span>
                      <div
                        style={{
                          fontFamily: 'Montserrat, sans-serif',
                          color: '#677179'
                        }}>
                        Generating Literature Review...{' '}
                      </div>
                    </span>
                  </div>
                )}
                {!loading && (
                  <div style={{ flex: 1 }}>
                    <div style={{ height: '450px', overflowY: 'auto', overflowX: 'hidden' }}>
                      {[...Array(litreviewDoc.length)].map((_, index) => (
                        <div key={index} style={{ marginBottom: '12px' }}>
                          <CollapsibleTextBox
                            title={`${litreviewDoc[index].title}`}
                            content={`${litreviewDoc[index].corpus}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Button Column on Right */}
                <div
                  style={{
                    marginLeft: '20px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    alignItems: 'left'
                  }}>
                  <div style={{ position: 'relative', display: 'inline-block' }}>
                    <button
                      onClick={() => setIsDownloadOpen(!isDownloadOpen)}
                      style={{
                        width: '140px',
                        height: '40px',
                        backgroundColor: '#009CDA',
                        border: '1px solid #DEE5EB',
                        borderRadius: 9999,
                        padding: '8px 12px',
                        color: 'black',
                        fontWeight: 'bold',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: 12,
                        margin: '0 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        cursor: 'pointer'
                      }}>
                      <img src={DownloadIcon} alt="icon" style={{ width: 16, height: 16 }} />
                      <span style={{ fontSize: 12, fontFamily: 'Montserrat, sans-serif', color: '#FFFFFF' }}>
                        Download as
                      </span>
                    </button>

                    {isDownloadOpen && (
                      <ul
                        style={{
                          position: 'absolute',
                          top: '100%', // 👈 directly below button
                          left: 0, // 👈 aligned with button
                          marginTop: 6, // small spacing
                          backgroundColor: '#fff',
                          border: '1px solid #DEE5EB',
                          borderRadius: 8,
                          boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                          listStyle: 'none',
                          padding: '4px 0',
                          width: '140px',
                          zIndex: 10
                        }}>
                        {downloadOptions.map(opt => (
                          <li
                            key={opt.value}
                            onClick={() => {
                              setIsDownloadOpen(false)

                              if (opt.value === 'word' && litReviewData) {
                                downloadLitReviewDocx(litReviewData)
                              }

                              if (opt.value === 'csv' && litReviewData) {
                                downloadLitReviewCsv(litReviewData)
                              }
                            }}
                            style={{
                              padding: '8px 12px',
                              cursor: 'pointer',
                              fontFamily: 'Montserrat, sans-serif',
                              fontSize: 12,
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#F3F4F6')}
                            onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}>
                            <img
                              src={opt.icon}
                              alt="icon"
                              style={{
                                width: 18,
                                height: 18,
                                filter: 'brightness(0) saturate(100%)'
                              }}
                            />
                            {opt.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <PrimaryButton
                    text="Open Filter Selections"
                    styles={openFilterButtonStyles}
                    onMouseEnter={() => setIsFilterHovered(true)}
                    onMouseLeave={() => setIsFilterHovered(false)}
                    onRenderIcon={() => (
                      <img
                        src={FilterIcon}
                        alt="icon"
                        style={{
                          filter: isFilterHovered ? 'none' : 'brightness(0) saturate(100%)',
                          transition: 'filter 0.3s ease-in-out',
                          width: 16,
                          height: 16,
                          paddingRight: 3
                        }}
                      />
                    )}
                    onClick={() => setIsArticleOpened(true)}></PrimaryButton>
                  <PrimaryButton
                    text="Restart"
                    styles={restartButtonStyles}
                    onMouseEnter={() => setIsRestartHovered(true)}
                    onMouseLeave={() => setIsRestartHovered(false)}
                    onClick={() => {
                      setactiveStep(0)
                      setLastConcludedStep(0)
                      setQuery('')
                      setcustomKeyword('')
                      setKeywords([])
                      setSelectedCountriesOptions([])
                      setSelectedSourceOptions([])
                      setSelectedDocTypeOptions([])
                      setUpperValue(2025)
                      setLowerValue(1945)
                      setSelectedButtons(Array(keywords.length).fill(false))
                      setSelectedDocButtons(
                        Object.fromEntries(
                          articles
                            .filter(article => article.id)
                            .map(article => [article.id!, false])
                        )
                      )
                      setIsRestartHovered(false)
                    }}
                    onRenderIcon={() => (
                      <img
                        src={RefreshIcon}
                        alt="icon"
                        style={{
                          filter: isRestartHovered ? 'none' : 'brightness(0) saturate(100%)',
                          transition: 'filter 0.3s ease-in-out',
                          width: 16,
                          height: 16,
                          paddingRight: 3
                        }}
                      />
                    )}></PrimaryButton>
                </div>
              </div>

              {/* Bottom Button */}
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <PrimaryButton
                  text="Previous step"
                  styles={previousStepButtonStyles}
                  onClick={() => {
                    setactiveStep(activeStep - 1)
                    setIsArticleOpened(false)
                  }}
                />
              </div>
            </Stack>
          </div>
        )}
        {activeStep == 2 && isArticleOpened && (
          <div
            style={{
              top: 0,
              right: 0,
              width: '350px',
              height: '100vh',
              backgroundColor: '#EAEFF9',
              color: '#404D59',
              fontFamily: 'Montserrat, sans-serif',
              padding: '40px 20px',
              overflowY: 'auto',
              textAlign: 'justify'
            }}>
            <PrimaryButton
              onClick={() => {
                setIsArticleOpened(false)
              }}
              style={{
                all: 'unset',
                background: 'transparent',
                border: 'none',
                padding: 0,
                paddingLeft: '-20px',
                margin: 0,
                width: 25,
                height: 25,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}>
              <img
                src={CloseIcon}
                alt="icon"
                style={{
                  width: 25,
                  height: 25,
                  filter:
                    'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)'
                }}
              />
            </PrimaryButton>
            <div style={{ paddingTop: '20px' }}>
              {openArticle?.title && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Title:</strong>
                  {openArticle.title}
                </div>
              )}

              {openArticle?.abstract && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Text:</strong>
                  {openArticle.abstract}
                </div>
              )}

              {openArticle?.authors && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Authors:</strong>
                  {openArticle.authors.join(', ')}
                </div>
              )}

              {openArticle?.date && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Date:</strong>
                  {openArticle.date}
                </div>
              )}

              {openArticle?.year && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Year:</strong>
                  {openArticle.year}
                </div>
              )}

              {openArticle?.document_type_raw && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Document type:</strong>
                  {openArticle.document_type_raw}
                </div>
              )}

              {openArticle?.language && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Language:</strong>
                  {openArticle.language}
                </div>
              )}

              {openArticle?.source && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>Source:</strong>
                  {openArticle.source}
                </div>
              )}

              {openArticle?.url && (
                <div>
                  <strong style={{ paddingTop: '10px', display: 'block' }}>URL:</strong>
                  <a
                    href={openArticle.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      wordBreak: 'break-all', // breaks long strings anywhere
                      whiteSpace: 'normal' // allows wrapping
                    }}>
                    {openArticle.url}
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
        {activeStep == 3 && isArticleOpened && (
          <div
            style={{
              top: 0,
              right: 0,
              width: '350px',
              height: '100vh',
              backgroundColor: '#EAEFF9',
              color: '#404D59',
              fontFamily: 'Montserrat, sans-serif',
              padding: '40px 20px',
              overflowY: 'auto',
              textAlign: 'justify'
            }}>
            <PrimaryButton
              onClick={() => {
                setIsArticleOpened(false)
              }}
              style={{
                all: 'unset',
                background: 'transparent',
                border: 'none',
                padding: 0,
                paddingLeft: '-20px',
                margin: 0,
                width: 25,
                height: 25,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}>
              <img
                src={CloseIcon}
                alt="icon"
                style={{
                  width: 25,
                  height: 25,
                  filter:
                    'brightness(0) saturate(100%) invert(53%) sepia(11%) saturate(314%) hue-rotate(162deg) brightness(91%) contrast(90%)'
                }}
              />
            </PrimaryButton>
            <div style={{ paddingTop: '20px' }}>
              <div style={{ fontSize: 30 }}>
                <strong style={{ paddingTop: '10px', paddingBottom: '20px', display: 'block' }}>
                  Filter Selections
                </strong>
              </div>
              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Question:</strong>
                {formatedQuery}
              </div>
              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Sources:</strong>
                {selectedSourceOptions.map(opt => String(opt.text) + '; ')}
              </div>
              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Countries:</strong>
                {selectedCountriesOptions.map(opt => String(opt.key) + '; ')}
              </div>
              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Document Type:</strong>
                {selectedDocTypeOptions.map(opt => String(opt.text) + '; ')}
              </div>

              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Selected Period:</strong>
                {lowerValue} - {upperValue}
              </div>

              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Selected Keywords:</strong>
                {keywordSelection}
              </div>

              <div>
                <strong style={{ paddingTop: '10px', display: 'block' }}>Selected References:</strong>

                {articles
                  .filter((_, i) => selectedDocButtons[i])
                  .map(article => (
                    <div key={article.id}>
                      {article.title}
                      <br />
                      <br />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default LitReview
